// --- Vendors ---
import 'jquery.marquee';
// --- Components ---
const home = {
    readyFn: function () {
        $('.marquee').marquee({
            duration: 5000,
            gap: 0,
            duplicated: true,
            duplicateCount: 3,
            pauseOnHover: true,
        });
    }
}
export { home };